import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import type { ArticleDTO } from '@amrita/shared';
import { TopBar } from '@/components/ui/TopBar';
import { Card } from '@/components/ui/Card';

interface BookmarksResp {
  articles: ArticleDTO[];
}

export default function BookmarksPage() {
  const nav = useNavigate();
  const { data, isLoading } = useQuery<BookmarksResp>({
    queryKey: ['bookmarks'],
    queryFn: () => api.get<BookmarksResp>('/api/training/bookmarks'),
  });

  return (
    <div className="safe-bottom min-h-full">
      <TopBar title="Закладки" />
      <div className="p-4 space-y-3">
        {isLoading && <div className="text-tg-hint text-sm">Загрузка…</div>}

        {data && data.articles.length === 0 && (
          <Card className="text-center text-tg-hint">
            Пока нет закладок. Открой статью → кнопка 🔖 добавит сюда.
          </Card>
        )}

        {data?.articles.map((a) => (
          <Card
            key={a.id}
            className="cursor-pointer hover:bg-tg-secondaryBg/70"
            onClick={() => nav(`/training/article/${a.id}`)}
          >
            <div className="font-semibold">{a.title}</div>
            {a.summaryMd && (
              <div className="text-sm text-tg-hint mt-1 line-clamp-3">{a.summaryMd}</div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}
